var app = angular.module('leonardo');

var DocumentListFolders = function (
  $scope,
  $q,
  FolderService,
  FolderFileService,
  $state,
  FilterService,
  $controller,
  PermissionService,
  $rootScope,
  $timeout,
  AttachmentService
) {
  $scope.folderFileService = FolderFileService;
  $scope.permissionService = PermissionService;
  $scope.attachmentService = AttachmentService;
  $scope.tableFilterSize = 20;

  $scope.getParamsFolders = function () {
    var filters = {
      account: FilterService.getFilter('account_reports'),
      managed_by_reports: FilterService.getFilter('managed_by_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      property: FilterService.getFilter('property_reports'),
      name: FilterService.getFilter('search'),
      sector: $scope.getSector(),
      roles: FilterService.getFilter('role')
    };
    if ($state.params.pk) {
      filters['parent'] = $state.params.pk;
    } else {
      switch ($scope.mode) {
        case 'normal':
          filters['root_type_tree'] = 'library';
          break;
        case 'property':
          filters['root_type_tree'] = 'setup_property';
          break;
        case 'portfolio':
          filters['root_type_tree'] = 'setup_portfolio';
          break;
        case 'account':
          filters['root_type_tree'] = 'setup_account';
          break;
      }
    }
    return filters;
  };

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
    var paramsFolders = $scope.getParamsFolders();
    angular.forEach(options, function (value, key) {
      paramsFolders[key] = value;
    });
    $scope.folders = [];
    $scope.loading = true;

    if ($state.params.pk) {
      FolderService.get($state.params.pk, true).then(function (folder) {
        $scope.currentFolder = folder;
        $rootScope.$broadcast('folder:loaded', folder);
        if (['documents.property', 'documents.portfolio'].includes($state.current.name)) {
          var breadcrumb = [];
          breadcrumb.push({ id: 0, name: $state.current.ncyBreadcrumb.label });
          angular.forEach(folder.breadcrumb, function (link) {
            breadcrumb.push(link);
          });
          $scope.currentFolder.breadcrumb = breadcrumb;
        }
      });
    }
    FolderService.getlist(paramsFolders).then(
      function (data) {
        $scope.folders = data.results ? data.results : data;
        $scope.loading = false;
        defer.resolve(data);
      },
      function (error) {
        $scope.loading = false;
        if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
          $scope.folders = [];
        }
        defer.resolve($scope.folders);
      }
    );

    return defer.promise;
  };

  $scope.thereResultsFolders = function () {
    var requirements = $scope.currentFolder ? $scope.currentFolder.requirements : [];
    return $scope.folders.length > 0 || requirements.length > 0;
  };

  $scope.$on('folder-file:created', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder-file:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder-file:deleted', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder:created', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder:deleted', function () {
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });

  $timeout(function () {
    $scope.loadPage($scope.page);
  }, 0);
};

app.controller('DocumentListFolders', [
  '$scope',
  '$q',
  'FolderService',
  'FolderFileService',
  '$state',
  'FilterService',
  '$controller',
  'PermissionService',
  '$rootScope',
  '$timeout',
  'AttachmentService',
  DocumentListFolders
]);
